var React = require('react');

function Notification (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"M12 2C15.866 2 19 5.13401 19 9V14C20.1046 14 21 14.8954 21 16C21 17.1046 20.1046 18 19 18H5C3.89543 18 3 17.1046 3 16C3 14.8954 3.89543 14 5 14V9C5 5.13401 8.13401 2 12 2ZM12 3C8.7616 3 6.12243 5.56557 6.00414 8.77506L6 9V15H5C4.44772 15 4 15.4477 4 16C4 16.5128 4.38604 16.9355 4.88338 16.9933L5 17H19C19.5523 17 20 16.5523 20 16C20 15.4872 19.614 15.0645 19.1166 15.0067L19 15H18V9C18 5.68629 15.3137 3 12 3ZM12 21C10.6938 21 9.58254 20.1652 9.17071 19H10.2676C10.6134 19.5978 11.2597 20 12 20C12.7403 20 13.3866 19.5978 13.7324 19H14.8293C14.4175 20.1652 13.3062 21 12 21Z"}));
}

Notification.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Notification;

Notification.default = Notification;
